import './components/index.js'
import './utils/insideNav.mjs'


console.info("%cscripts loaded", "color: green; background: lightgreen; padding: 5px 20px; border: 1px solid green;")